module.exports = __webpack_public_path__ + "PR1-3e3b8a5f.webp";